import { FC } from 'react';
import { Select, MenuItem } from '@material-ui/core';
import styled from '@emotion/styled';

import { ChartBreakdown } from '@kaizenplatform/kaizen-chartjs';

type Props = {
  chartBreakdowns?: ChartBreakdown[] | null;
  selectedDate: string;
  handleChangePageTableChartDate: (event: any) => void;
};

const PageTableChartDateSelector: FC<Props> = ({ chartBreakdowns, selectedDate, handleChangePageTableChartDate }) => {
  const dateBreakdown = chartBreakdowns ? chartBreakdowns.find((breakdown) => breakdown.key.label === 'date') : null;
  const dates = dateBreakdown ? dateBreakdown.values : null;
  return dates ? (
    <DateSelect>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={selectedDate}
        onChange={handleChangePageTableChartDate}
      >
        {dates.map((date, idx) => {
          return (
            <MenuItem key={idx} value={date}>
              {date.replace(/-01$/, '')}
            </MenuItem>
          );
        })}
      </Select>
    </DateSelect>
  ) : null;
};

const DateSelect = styled('div')(`
  padding-left: 24px;
  margin-bottom: 8px;
`);

export default PageTableChartDateSelector;
